import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto_Condensed\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-roboto-condensed\",\"preload\":true}],\"variableName\":\"robotoCondensed\"}");
;
import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/navigation/MainNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/navigation/TopNav.tsx");
